export default "__VITE_ASSET__DHYoBa5r__"